import settings from '@/settings'

let list = (headers, paraAbastecimento) => {
  return fetch(`${settings.apetrusApi}/automacoes/?para_abastecimento=${paraAbastecimento}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let selecionar = (data, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/automacoes/postos/selecionarautomacao/?cnpj=${cnpj}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

let carregarAutomacao = (cnpj, headers, paraAbastecimento) => {
  return fetch(`${settings.apetrusApi}/automacoes/postos/?cnpj=${cnpj}&para_abastecimento=${paraAbastecimento}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  list,
  selecionar,
  carregarAutomacao
}
